import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import LoadingSpinner from './components/ui/LoadingSpinner';

// Lazy load pages for performance
const ModernLanding = React.lazy(() => import('./pages/ModernLanding'));
const SeasonsPage = React.lazy(() => import('./pages/SeasonsPage'));
// const SeasonDetailPage = React.lazy(() => import('./pages/SeasonDetailPage'));
const RaceCalendarPage = React.lazy(() => import('./pages/RaceCalendarPage'));
const SessionSelectionPage = React.lazy(() => import('./pages/SessionSelectionPage'));
const TelemetryPage = React.lazy(() => import('./pages/TelemetryPage'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/RegisterPage'));

// Loading fallback component
const PageLoader = () => (
  <div className="min-h-screen bg-gradient-to-br from-f1-black to-f1-gray-800 flex items-center justify-center">
    <div className="text-center">
      <LoadingSpinner size="lg" className="mb-4" />
      <p className="text-f1-gray-300">Loading page...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<ModernLanding />} />
          <Route path="/seasons" element={<SeasonsPage />} />
          <Route path="/seasons/:year" element={<RaceCalendarPage />} />
          <Route path="/seasons/:year/races/:raceId" element={<SessionSelectionPage />} />
          <Route path="/sessions/:sessionId/telemetry" element={<TelemetryPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
        </Routes>
      </Suspense>
    </AuthProvider>
  );
}

export default App;